import React from "react";
import { H2sPopupContainer } from "./popupTableHelper";
import { displayedIndicator, getColor } from "./popupHelper";
import ReactDOMServer from "react-dom/server";
import { getH2sDataColor } from "../table/tableHelper";
import { EventsPluieApi, H2sPopupApi } from "../../api";

export const getInfoH2s = async (feature) => {
  // Get H2S indicator name
  const indicatorModule: string | null =
    window.sessionStorage.getItem('h2s_indicator');
  let content = document.createElement('div');
  let attributes = feature.graphic.attributes;
  const indicator = getH2sDataColor();
  const categoriesOnly =
    attributes[indicator] !== 'NOIR' && attributes[indicator] !== 'GRIS';
  const dateRemontee = categoriesOnly
    ? attributes['RecordDate'+indicator.slice(5)]
    : 'Pas de télégestion';

  // Ensure we have the latest indicator data
  if (!attributes[indicator] && indicatorModule) {
    console.warn(`Missing data for indicator ${indicator} in attributes`);
  }

  const formatDateToIsoDateOnly = (date?: string) => {
      if (!date) return date;
    
      const parts = date.split('/');
      if (parts.length !== 3) return date;
    
      const [day, month, year] = parts;
      return `${year}-${month}-${day}`;
    };

  const recordDate = formatDateToIsoDateOnly(
      attributes['RecordDate' + indicator.slice(5)]
    );
  const h2sCateg = H2sPopupApi.getH2sCateg(attributes.Code, recordDate);
  const povInfo = EventsPluieApi.getInstallPov(attributes.Code);

  const [povValue, h2sValue] = await Promise.allSettled([povInfo, h2sCateg]);

  let idPov = 'NR';
  if (povValue.status === 'fulfilled' && povValue.value) {
    idPov = povValue.value.data;
  }

  const normalizeH2sKeys = (data) => {
    if (!data) return data;
  
    const normalized = {};
  
    Object.keys(data).forEach((key) => {
     
      const fixedKey = key.charAt(0).toUpperCase() + key.slice(1);
      normalized[fixedKey] = data[key];
    });
  
    return normalized;
  };
  
  if (h2sValue.status === 'fulfilled') {
    const normalized = normalizeH2sKeys(h2sValue.value.data);
    attributes = {
      ...attributes,
      ...normalized
    };
  }

  const tableElements = {
    'Boon&Lister (mg/l)': [
      getColor(attributes.ColorBoonLister),
      attributes.ValueBoonLister,
    ],
    'Tps séjour cana(h)': [
      getColor(attributes.ColorSejourCana),
      attributes.ValueSejourCana,
    ],
    'Tps séjour PR(dem/j)': [
      getColor(attributes.ColorSejourPR),
      attributes.ValueSejourPR,
    ],
    'Vit autocurage(m/s)': [
      getColor(attributes.ColorAutocurage),
      attributes.ValueAutocurage,
    ],
    Terrain: [getColor(attributes.ColorTerrain), attributes.ValueTerrain],
    POV: [null, idPov],
  };

  content.innerHTML = ReactDOMServer.renderToString(
    <H2sPopupContainer
      title={attributes?.Description}
      dateRemontee={dateRemontee}
      tableElements={tableElements}
      indicator={displayedIndicator(indicatorModule!)}
    />
  );
  return content;
};